import React from 'react'
import './WorkM.scss';
import WorkImage from '../../../../assets/WorkImage.png';

export default function WorkM() {
  return (
    <div className='work-container'>
      <div className='left-section'>
        <img src={WorkImage} alt="credit detail" />
      </div>
      <div className='right-section'>
        <h1>How M Coins Work?</h1>
        <p>
          Each time you use a premium feature—such as compressing a file, merging PDFs, converting formats, or editing—you’ll use a small number of M Coins. This system allows fair, scalable access based on your actual usage.
        </p>
      </div>
    </div>
  )
}
